export interface MijnFeedbackSettings {
    channelId: string;
    moodId: string;
    moodTitle: string;
    commentsId: string;
    customThankYouMessage?: string;
    type?: Variants;
    sidebarLabel?: string;
    metadata?: { [key: string]: string };
    retailMetadata?: string;
}

export type MijnFeedbackVariant = keyof typeof Variants;

export enum Variants {
    MOOD_FULL = 'MOOD-FULL',
    MOOD_SIDEBAR = 'MOOD-SIDEBAR'
}

export interface RequiredMetadata {
    formName: Uppercase<string>;
    isObeyaRapportageItem: 'JA' | 'NEE';
}

export type BrandNumbers = '28' | '230' | '270' | '40';
export type CustomerTypes = 'ZAKELIJK' | 'PARTICULIER';
export type PlatformTypes = 'MIJN' | 'APP' | 'RETAIL';

export interface RetrievableMetadata {
    brandNumber: BrandNumbers;
    customerType: CustomerTypes;
    platform: PlatformTypes;
    userAgent: string;
}
